import { useCallback } from 'react';

import { useAgendaGeneration, type AgendaGenerationRequest } from './useAgendaGeneration';

import { managerAssessmentService } from '@/api/cycle-evaluation-services/manager-assessment';

/** The post-review meeting's agenda generation, for the review cycle `cycleInstanceId`. */
export function useMeetingAgenda(cycleInstanceId: string) {
    const request = useCallback<AgendaGenerationRequest>(
        (input) => managerAssessmentService.generateAgenda({ cycleInstanceId, ...input }),
        [cycleInstanceId],
    );

    return useAgendaGeneration(request);
}
